import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Directive({
  selector: '[urlDownload]'
})
export class UrlDownloadDirective {
  @Input() urlDownload: string;
  @Input() fileName: string
  constructor(
    private el: ElementRef, 
    private renderer: Renderer2,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {
  }

  @HostListener('click')
  onHostClick() {
    this.renderer.addClass(this.el.nativeElement, 'loading')
    this.http.get(this.urlDownload, {
      responseType: 'blob'
    }).subscribe(
      blob => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = this.fileName || 'download.pdf';
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.renderer.removeClass(this.el.nativeElement, 'loading')
      },
      err => {
        this.renderer.removeClass(this.el.nativeElement, 'loading')
        var reader = new FileReader();
        reader.onload = () => {
          this.snackBar.open(reader.result.toString(), null, { duration: 3000 });
        }
        reader.readAsText(err.error);
      })
  }
}
